import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './vendors.css';
import { fetchCategories } from '../../API/Resources/fetchCategories'
import DynamicBreadcrumbs from '../dynamic_breadcumb/dynamic_breadcrumb';
import { useNavigate } from 'react-router-dom';
import DownloadAppUI from '../../ui_components/download_app/download_app';
import SiteFooter from '../../ui_components/site_footer/site_footer';

export default function Vendors() {

  const navigate = useNavigate();
  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem("token")
    if (storedToken) {
      return storedToken;
    }
    else {
      return null;
    }
  }, []);
  const [categories, setCategories] = useState([{}]);
  useEffect(() => {
    const loadCategories = async () => {
      const cate_data = await fetchCategories()
      if (cate_data) {
        setCategories(cate_data);
      }
    }
    loadCategories();
  }, [token]);

  const handleCardClick = (category) => {
    const path = `/vendors/${category.category_name.replace(/\s+/g, '-')}`;
    navigate(path);
  };

  return (
    <>
      <Container className="my-2">
        <div className="mb-0">
          <DynamicBreadcrumbs />
          <span id="wedding-category-title">Wedding Categories</span>
        </div>
        <Row className="g-4 align-items-stretch h-auto">

          {
            categories.length == 0 && <>
              <h3 className='text-center'>No Categories found</h3>
            </>
          }
          {categories.map((category, index) => (
            <Col xs={12} md={6} lg={6} key={index}>
              <Card className="category-card h-100" style={{ background: `${category.color}` }} onClick={() => handleCardClick(category)}>
                <div className="row g-0 h-100" id='card-content'>
                  <div className="col-8 m-0 px-3">
                    <div>
                      <Card.Title className="mb-0 fw-bold text-muted" id="card-title">{category.category_name}</Card.Title>
                      <Card.Text id="card-sub-title">{category.category_name}</Card.Text>
                    </div>
                  </div>
                  <div className="m-0 p-0 col-4 d-flex flex-column justify-content-center align-items-center">
                    <Card.Img src={"https://imgs.search.brave.com/k8tHy70ypZ6RBPw5BZZ3eLkDyUckmYCIoTE7Zmi49GY/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMjE5/OTk4MzU4OS9waG90/by9oYXBweS1icmlk/ZS1zaG93aW5nLWhl/ci1lYXJyaW5nLXRv/LWdyb29tLWluLXdl/ZGRpbmctY2VyZW1v/bnkuanBnP3M9NjEy/eDYxMiZ3PTAmaz0y/MCZjPUp6TnRyR3ll/RDRzNGEyX0tBd3Yw/UXotRTZmUXNTVWZv/Tkg0RFF5MzlkVk09"} className="img-fluid rounded-end" id='categoery_image' alt={`Image for ${category.category_name}`} />
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
        <section className='my-4'>
          {/* Download the app */}
          <div id='download-app-container' className='m-0'>
            <DownloadAppUI />
          </div>

          {/* Site Footer */}
          <div>
            <SiteFooter />
          </div>
        </section>
      </Container>


    </>
  );
};